import { oz } from '@weft/utils';
import { ObjectIdSchema } from '../../primitives';
import { BillingCycleStatusSchema } from './billing-cycle-status-schema';

export const NewBillingCycleSchema = oz.object({
  name: oz.string().nonempty(),
  billingDay: oz.number().min(1).max(25),
  status: BillingCycleStatusSchema,
  customersIds: oz.array(ObjectIdSchema).optional(),
}).openapi('NewBillingCycle');

export type NewBillingCycle = oz.infer<typeof NewBillingCycleSchema>;